import FanMassEditModal from './FanMassEditModal';

export default FanMassEditModal;
